document.addEventListener("DOMContentLoaded", function () {

    // Select all product containers
    let productContainers = document.querySelectorAll(".products-container-wrapper");

    if (productContainers.length === 0) {
        console.error("No product containers found.");
        return;
    }

    productContainers.forEach(container => {
        let collectionHandle = container.getAttribute("data-collection-handle").trim(); // Get collection handle

        if (!collectionHandle) {
            console.warn("No collection assigned for this container.");
            return; // Skip containers without a valid collection
        }

        // Shopify API URL to fetch products from the selected category
        let collectionUrl = `/collections/${collectionHandle}/products.json?limit=50`;

        fetch(collectionUrl)
            .then(response => response.json())
            .then(data => {
                let products = data.products || [];

                if (products.length === 0) {
                    console.warn(`No products found in the "${collectionHandle}" collection.`);
                    return;
                }

                // Shuffle function using Fisher-Yates algorithm
                function shuffleArray(array) {
                    for (let i = array.length - 1; i > 0; i--) {
                        let j = Math.floor(Math.random() * (i + 1));
                        [array[i], array[j]] = [array[j], array[i]]; // Swap elements
                    }
                }

                shuffleArray(products); // Shuffle the fetched products

                //  Check if the current page is the product detail page

                let isProductDetailPage = window.location.pathname.startsWith('/products/');

                // Keep only 10 shuffled products (or 5 if it's the product detail page)
                let numProductsToDisplay = isProductDetailPage ? 5 : 10;
                let selectedProducts = products.slice(0, numProductsToDisplay);


                // Clear the container before appending new products
                container.innerHTML = "";

                // Function to format price correctly (Shopify uses cents)
                function formatPrice(priceInCents) {
                    return priceInCents; // Convert cents to dollars
                }

                // Append selected products to the specific container
                selectedProducts.forEach(product => {
                    let variant = product.variants[0]; // Get first variant
                    let price = formatPrice(variant.price);
                    let comparePrice = variant.compare_at_price ? formatPrice(variant.compare_at_price) : null;

                    // Ensure compare price is only displayed if it's greater than the actual price
                    let comparePriceHTML = comparePrice && comparePrice > price
                        ? `<span class="compare-price">$${comparePrice}</span>`
                        : '';

                    let productHTML = `
    <div class="product-wrapper sale-wrapper-product">
      <div class="product-card">
          <div class="quick-view-button card_eye_icon" data-handle="${product.handle}">
              <i class="fa fa-eye"></i>
          </div>
          <div class="wishlist-engine icon_show_color" 
              data-product_id="${product.id}" 
              data-variant_id="${variant.id}" 
              data-full_button="false" data-css="true">
          </div>
          <div class="image-wrapper-product">
              <a href="/products/${product.handle}"><img src="${product.images.length > 0 ? product.images[0].src : 'path/to/placeholder-image.jpg'}" alt="${product.title}" /></a>
          </div>
          <a class="card_text_black" href="/products/${product.handle}"><h4>${product.title}</h4></a>
          <div class="price-wrapper">
              <p class="price">$${price}</p>
              ${comparePriceHTML}
          </div>
          <div class="card_btn_flex collection_btn_outer_space pb-2">
                  <div class="productView-moreItem more-items-on-collection">
                      <form method="post" action="/cart/add" id="product-form-${product.id }" accept-charset="UTF-8" class="form asd" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                         <input type="hidden" name="form_type" value="product">
                         <input type="hidden" name="utf8" value="✓">
                          <div class="productView-group">
                              <div class="pvGroup-row">
                          <quantity-input class="productView-quantity quantity__group quantity__group--2 quantity__style--2 clearfix">
                              <label class="form-label quantity__label" for="quantity-${product.id}-2">
                                  {{ 'products.product.quantity.label__2' | t }}
                              </label>
                              <div class="quantity__container">
                                  <button type="button" name="minus" class="minus btn-quantity">
                                      <span class="visually-hidden">{{ 'products.product.quantity.decrease' | t: product: product.title | escape }}</span>
                                  </button>
                                  <input class="form-input quantity__input" type="number" name="quantity" min="1" value="1" inputmode="numeric" pattern="[0-9]*" id="quantity-{{ product.id }}{%- if quantity_stt > 1 -%}-2{%- endif -%}" data-product="{{ product.id }}" data-price="${product.variants[0].price}">
                                  <button type="button" name="plus" class="plus btn-quantity">
                                      <span class="visually-hidden">{{ 'products.product.quantity.increase' | t: product: product.title | escape }}</span>
                                  </button>
                              </div>
                          </quantity-input>
                                  <div class="productView-groupTop">
                                      <div class="productView-action scroll-trigger animate--slide-in" >
                                          <input type="hidden" name="id" value="${product.variants[0].id}">
                                          <div class="product-form__buttons">
                                            <button type="submit" name="add" data-btn-addtocart="" data-inventory-quantity="1" data-available="false" class="product-form__submit button button--primary an-horizontal-shaking" id="product-add-to-cart">
                                              Add to cart
                                            </button>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <input type="hidden" name="product-id" value="${product.id}"><input type="hidden" name="section-id" value="template--17025178239046__main">
                      </form>
                  </div>
              <a href='https://elysianoble.com/cart/add?id=${product.variants[0].id}&quantity=1&return_to=/checkout' class="buy-now-button">Buy Now</a>
          </div>
      </div>
  </div>
`;

                    container.innerHTML += productHTML;
                });

                // Attach event listeners to quick view buttons *after* they are added
                let quickViewButtons = container.querySelectorAll('.quick-view-button');

                quickViewButtons.forEach(button => {
                    button.addEventListener('click', function (event) {
                        event.preventDefault(); // Prevent default link behavior

                        const swatch = event.target.closest('.quick-view-button'); // Target the correct element

                        if (swatch) {
                            let productTitle = swatch.getAttribute('data-handle');
                            let productUrl = `${window.location.origin}/products/${productTitle}.js`;

                            // Fetch product data (your existing fetch code from quick-view.js)
                            fetch(productUrl)
                                .then(response => {
                                    if (!response.ok) {
                                        throw new Error('Network response was not ok ' + response.statusText);
                                    }
                                    return response.json();
                                })
                                .then(data => {
                                    let modalWrapper = document.querySelector('.modalWrapper');
                                    if (modalWrapper) {
                                        modalWrapper.classList.add('active');

                                        // Extract product details with safe fallback values
                                        let title = data.title || "Unknown Product";
                                        let sale_price = data.price_min || "";
                                        let compare_price = data.compare_at_price || "";
                                        let images = Array.isArray(data.images) ? data.images : [];
                                        let description = data.description || "";

                                        // Select elements safely
                                        let sliderContainer = document.querySelector('.product-side-quick_view-slider');
                                        let titleElement = document.querySelector('.product-title-side-quick_view');
                                        let salePriceElement = document.querySelector('.current-sale-price');
                                        let comparePriceElement = document.querySelector('.current-compare-price');
                                        let descriptionElement = document.querySelector('.product-description-qucik_view');

                                        // Clear previous images before appending new ones (if slider exists)
                                        if (sliderContainer) {
                                            sliderContainer.innerHTML = '';

                                            // Append new images safely
                                            images.forEach(function (imageSrc) {
                                                if (imageSrc) { // Ensure imageSrc is not empty
                                                    let imgElement = document.createElement('img');
                                                    imgElement.src = imageSrc;
                                                    sliderContainer.appendChild(imgElement);
                                                }
                                            });
                                        }

                                        // Update product details safely
                                        if (titleElement) titleElement.textContent = title;
                                        if (salePriceElement) salePriceElement.textContent = sale_price;
                                        if (comparePriceElement) {
                                            if (compare_price > sale_price) {
                                                comparePriceElement.textContent = compare_price;
                                            } else {
                                                comparePriceElement.textContent = ""; // Hide if compare price is lower
                                            }
                                        }
                                        if (descriptionElement) descriptionElement.innerHTML = description; // Render HTML safely

                                        // Initialize slick slider only if images exist and slider container is present
                                        if (sliderContainer && images.length > 0 && typeof $ !== "undefined") {
                                            $(sliderContainer).slick({
                                                slidesToShow: 1,
                                                arrows: true,
                                                dots: false,
                                            });
                                        }

                                        // Delay adding active class to modal content safely
                                        let modalContainer = document.querySelector('.modalWrapper .container');
                                        if (modalContainer) {
                                            setTimeout(function () {
                                                modalContainer.classList.add('active');
                                            }, 200);
                                        }

                                    }
                                })
                                .catch(error => {
                                    console.log('There was a problem with the fetch operation:', error);
                                });
                        }
                    });
                });
            })
            .catch(error => console.error("Error fetching products:", error));
    });
});